import React from "react";
import "./ProfileModal.scss";
import images from "../../../../assets/Icons/Icons";

interface ProfileModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSettings: () => void;
  onHelp: () => void;
  onLogout: () => void;
  userName: string;
}

const ProfileModal: React.FC<ProfileModalProps> = ({
  isOpen,
  onClose,
  onSettings,
  onHelp,
  onLogout,
  userName,
}) => {
  if (!isOpen) return null;

  return (
    <div className="profile-modal-backdrop" onClick={onClose}>
      <div className="profile-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="profile-header">
          <h2>{userName}</h2>
          <button className="close-btn" onClick={onClose}>
            <img src={images.crossIcon} width={50} height={46} />
          </button>
        </div>

        <div className="divide" />

        {/* Settings */}
        <div className="menu-item settings" onClick={onSettings}>
          <span>Settings</span>
          <img src={images.forwardIcon} width={30} height={30} />
        </div>

        <div className="divide" />

        {/* Help */}
        {/* <div className="menu-item muted" onClick={onHelp}>
          <div className="icon help">
            <img src={images.askIcon} alt="help" width={22} height={22} />
          </div>
          <span>Help</span>
        </div> */}

        {/* Logout */}
        <div className="menu-item muted logout" onClick={onLogout}>
          <div className="icon logout">
            <img
              src={images.logouticon}
              className="logout-icon"
              alt="Logout"
              width={22}
              height={22}
            />
          </div>
          <span>Log out</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileModal;
